import { UpdateIcon } from '@bp/ui-components';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { useEventJobRunning } from '../../hooks/useEventJobRunning';
import styles from './EventJobRunningBanner.module.scss';

export const EventJobRunningBanner = observer(() => {
  const { t } = useTranslation();
  const isRunning = useEventJobRunning();

  if (!isRunning) return null;

  return (
    <div className={styles.banner}>
      <UpdateIcon className='svg-icon spinning' />
      {t('synchronizations.runningBanner')}
    </div>
  );
});

EventJobRunningBanner.displayName = 'EventJobRunningBanner';
